/**
 * Tips at checkout (rule "tips", off by default): settings card, POS tip step, refund, daily close, reports.
 * One row per key: [key, English, 中文]; Malay falls back to English. Registered in ../modules.ts.
 */
const ROWS = [
  ["tip.set.title","Tips","小费"],
  ["tip.pay.items","Items","项目"],
  ["tip.pay.terminal","Enter on card terminal: {amount}","请在刷卡机输入：{amount}"],
  ["tip.pay.terminalTip","(incl. {tip} tip)","（含小费 {tip}）"],
  ["tip.set.intro","Let customers add a tip before they pay. Tips are never sales revenue and never earn commission. Off by default.","顾客付款前可加小费。小费不计入营业额，也不计提成。默认关闭。"],
  ["tip.set.enabled","Ask for a tip at checkout","结账时请顾客给小费"],
  ["tip.set.presets","Suggested tips (%)","建议小费比例（%）"],
  ["tip.set.presetsHint","Comma-separated, up to 6. Empty = your country's defaults ({list}).","用逗号分隔，最多 6 个。留空 = 本国默认（{list}）。"],
  ["tip.set.allowCustom","Allow a custom amount","允许自定义金额"],
  ["tip.set.noTipAlways","\"No tip\" is always offered.","始终提供「不给小费」按钮。"],
  ["tip.set.base","Calculate the % on","百分比计算基数"],
  ["tip.set.base.pre_tax","Subtotal before tax","税前小计"],
  ["tip.set.base.post_tax","Total with tax","含税总额"],
  ["tip.set.recipient","Who receives tips","小费归谁"],
  ["tip.set.recipient.line_staff","Staff on each service (split by service value)","每项服务的员工（按服务金额分配）"],
  ["tip.set.recipient.staff","One staff member","指定一位员工"],
  ["tip.set.staff","Staff member","员工"],
  ["tip.set.payslip","Show tips on payslips (own line, not commission)","工资单显示小费（单独一行，不算提成）"],
  ["tip.set.saved","Saved","已保存"],
  ["tip.set.badPresets","Enter percentages between 0.01 and 100, separated by commas.","请输入 0.01 至 100 之间的百分比，用逗号分隔。"],
  ["tip.pos.title","Add a tip?","加小费吗？"],
  ["tip.pos.of","Tip on {amount}","小费基数 {amount}"],
  ["tip.pos.noTip","No tip","不给小费"],
  ["tip.pos.custom","Custom amount","自定义金额"],
  ["tip.pos.add","Add tip {amount}","加小费 {amount}"],
  ["tip.pos.tip","Tip","小费"],
  ["tip.pos.change","Change tip","修改小费"],
  ["tip.pos.goesTo","Goes to {name}","归 {name}"],
  ["tip.pos.split","Split between the staff on the services","按服务分给相关员工"],
  ["tip.pos.locked","The tip can't be changed after a payment.","已收款后不能修改小费。"],
  ["tip.pos.due","Due incl. tip","含小费应付"],
  ["tip.refund.label","Refund tip","退还小费"],
  ["tip.refund.hint","Tip left: {amount}. Refunding every item also refunds the rest of the tip.","剩余小费 {amount}。退还全部项目时，剩余小费会一并退还。"],
  ["tip.close.title","Tips","小费"],
  ["tip.close.total","Tips received","收到的小费"],
  ["tip.close.refunded","Tips refunded","已退小费"],
  ["tip.close.exclTips","Collected excl. tips","不含小费的收款"],
  ["tip.close.note","Included in collections and expected cash, never in sales revenue.","已计入收款和应有现金，但不计入营业额。"],
  ["tip.unassigned","Unassigned","未分配"],
  ["tip.report.title","Tips by staff (not revenue)","员工小费（不计营业额）"],
  ["tip.report.orders","Sales","单数"],
  ["tip.report.refunded","Refunded","已退"],
] as const;
export type TipKey = (typeof ROWS)[number][0];
const col = (i: 1 | 2) => Object.fromEntries(ROWS.map((r) => [r[0], r[i]])) as Record<TipKey, string>;

export const taskTIP = { en: col(1), zh: col(2), ms: col(1) };
